import LegalLayout from "@/components/LegalLayout";

export default function AGB() {
    return (
        <LegalLayout title="Allgemeine Geschäftsbedingungen" eyebrow="AGB · Spenden · Widerruf">
            <section>
                <h2>§ 1 Geltungsbereich und Anbieterin</h2>
                <p>
                    Diese Allgemeinen Geschäftsbedingungen („AGB") gelten für Verträge
                    zwischen
                </p>
                <p>
                    Stickerbag, Inhaberin Isabell Helmund<br />
                    In der Straße der Jugend 18<br />
                    14974 Ludwigsfelde<br />
                    E-Mail: lunarislp@gmx.de, Telefon: +49 176 82337092
                </p>
                <p>und dir („Nutzer:in") über die Nutzung der Plattform Taubenwacht.</p>
            </section>

            <section>
                <h2>§ 2 Leistungen</h2>
                <p>
                    Taubenwacht ist eine Plattform mit drei Bereichen:
                </p>
                <ul className="list-disc ml-6 mt-3 space-y-1">
                    <li>
                        <strong>Digitaler Taubenhimmel</strong> — Erinnerungsort. Gegen Zahlung
                        einer einmaligen Pauschale von 2,00 € erhältst du einen einmaligen
                        Code, mit dem du eine Gedenkseite anlegst.
                    </li>
                    <li>
                        <strong>Himmelsfond</strong> — Hilfsfonds für lebende Stadttauben. Von
                        jeder Eintragspauschale fließt 1,00 € in den Fonds. Zusätzlich sind
                        freiwillige Spenden möglich, die zu 100 % im Fonds verbleiben.
                    </li>
                    <li>
                        <strong>Vermittlung</strong> — Anzeigenplattform für Stadttauben, die ein
                        Zuhause suchen. Anbieter und Interessenten treten direkt in Kontakt.
                    </li>
                </ul>
            </section>

            <section>
                <h2>§ 3 Vertragsschluss Taubenhimmel-Eintrag</h2>
                <p>
                    Mit dem Klick auf den Bezahl-Button gibst du ein verbindliches Angebot
                    ab. Der Vertrag kommt mit Bestätigung der Zahlung durch den
                    Zahlungsdienstleister zustande. Du erhältst einen einmaligen Code zur
                    Einrichtung einer Gedenkseite.
                </p>
            </section>

            <section>
                <h2>§ 3a Keine Rückerstattung</h2>
                <p>
                    <strong>Sämtliche Zahlungen an Taubenwacht sind endgültig und werden nicht
                    erstattet.</strong> Dies gilt insbesondere für:
                </p>
                <ul className="list-disc ml-6 mt-3 space-y-1">
                    <li>gekaufte Eintrags-Codes für den Digitalen Taubenhimmel (auch wenn
                        der Code nicht eingelöst wird);</li>
                    <li>bereits veröffentlichte Gedenkseiten, die du später selbst änderst,
                        archivierst oder löschst;</li>
                    <li>vom Admin moderierte oder entfernte Inhalte, sofern ein Verstoß
                        gegen diese AGB vorliegt;</li>
                    <li>freiwillige Spenden in den Himmelsfond (siehe § 4).</li>
                </ul>
                <p>
                    Das Löschen einer Gedenkseite oder eines Vermittlungs-Inserats führt
                    nicht zu einer (auch nicht anteiligen) Rückerstattung der gezahlten
                    Beträge. Das gesetzliche Widerrufsrecht für digitale Inhalte bleibt im
                    Rahmen der unten stehenden Widerrufs­belehrung unberührt.
                </p>
            </section>

            <section>
                <h2>§ 4 Spenden in den Himmelsfond</h2>
                <p>
                    Spenden sind freiwillig und ohne Gegenleistung. Sie fließen
                    zweckgebunden in die Unterstützung lebender Stadttauben (Tierarzt­kosten,
                    Päppel-Material, Notfälle). Eine Spendenquittung wird auf Anfrage per
                    E-Mail ausgestellt.
                </p>
            </section>

            <section>
                <h2>§ 5 Inhalte und Nutzerpflichten</h2>
                <p>
                    Du sicherst zu, dass du an allen hochgeladenen Inhalten (Bilder, Texte)
                    die erforderlichen Rechte besitzt und keine Rechte Dritter verletzt.
                    Inhalte dürfen nicht beleidigend, rechtswidrig oder kommerziell sein.
                </p>
                <p>
                    Wir behalten uns vor, Inhalte zu prüfen, zu sperren oder zu löschen,
                    insbesondere bei Verstößen gegen diese AGB.
                </p>
            </section>

            <section>
                <h2>§ 6 Verfügbarkeit</h2>
                <p>
                    Wir bemühen uns um hohe Verfügbarkeit, garantieren jedoch keine
                    ununterbrochene Erreichbarkeit. Wartungen und Störungen bei
                    Drittanbietern können zu kurzfristigen Einschränkungen führen.
                </p>
            </section>

            <section>
                <h2>§ 7 Haftung</h2>
                <p>
                    Wir haften unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei
                    Verletzung von Leben, Körper, Gesundheit und nach ProdHaftG. Im Übrigen
                    beschränkt sich die Haftung bei leichter Fahrlässigkeit auf die
                    Verletzung wesentlicher Vertragspflichten und auf den
                    vertragstypischen, vorhersehbaren Schaden.
                </p>
            </section>

            <section>
                <h2>§ 8 Anwendbares Recht</h2>
                <p>
                    Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Zwingende
                    Schutzvorschriften deines Aufenthaltsstaates bleiben unberührt.
                </p>
            </section>

            <hr className="border-white/10 my-12" />

            <section>
                <h2>Widerrufsbelehrung — digitale Inhalte (Eintrags-Code)</h2>
                <p>
                    Du hast das Recht, binnen <strong>vierzehn Tagen</strong> ohne Angabe von Gründen
                    den Vertrag über den Erwerb eines Eintrags-Codes zu widerrufen, sofern
                    der Code noch nicht zur Erstellung einer Gedenkseite genutzt wurde.
                </p>
                <p>
                    <strong>Hinweis:</strong> Sobald du den Code einlöst und eine Gedenkseite
                    veröffentlichst, beginnt die unmittelbare Erbringung der digitalen
                    Leistung. Mit deiner ausdrücklichen Zustimmung dazu (Checkbox bei der
                    Veröffentlichung) <strong>erlischt das Widerrufsrecht</strong> gemäß § 356
                    Abs. 5 BGB.
                </p>
                <p>
                    Spenden in den Himmelsfond sind freiwillige Zuwendungen ohne
                    Gegenleistung und unterliegen keinem Widerrufsrecht.
                </p>
                <h3>Widerruf erklären</h3>
                <p>
                    Stickerbag, Isabell Helmund, In der Straße der Jugend 18, 14974
                    Ludwigsfelde — E-Mail: lunarislp@gmx.de
                </p>
            </section>

            <p className="text-xs text-[#64748b] pt-8 border-t border-white/10">
                Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
            </p>
        </LegalLayout>
    );
}
